export const UserRouter = [
  {
    path: '/my-data',
    name: 'MyData',
    component: () => import('@/views/user/MyData.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/user/Profile.vue')
  },
  {
    path: '/my-favorites',
    name: 'MyFavorites',
    component: () => import('@/views/user/MyFavorites.vue')
  },
  {
    path: '/users/:id/favorites',
    name: 'UserFavorites',
    component: () => import('@/views/user/Favorites.vue')
  },
  {
    path: '/auth/sign-up',
    name: 'SignUp',
    component: () => import('@/views/auth/SignUp.vue')
  }
];